import React from 'react'

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.warn('[CosmosBrainPower] Recovered from render error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0a0d14] text-white flex flex-col items-center justify-center p-6 text-center">
          <div className="w-16 h-16 rounded-full bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center mb-4 text-cyan-400 text-2xl">
            🧠
          </div>
          <h2 className="text-xl font-bold mb-2">Sincronizando Sinapsis...</h2>
          <p className="text-gray-400 text-sm max-w-sm mb-6">
            Ocurrió un ajuste en la interfaz. Haz clic para restablecer el estado del entrenamiento.
          </p>
          <button
            type="button"
            onClick={() => this.setState({ hasError: false, error: null })}
            className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-cyan-500 to-blue-600 font-semibold text-sm text-white shadow-lg shadow-cyan-500/20 active:scale-95 transition-all"
          >
            Reconectar
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
